module.exports = __webpack_public_path__ + "media/images/icons/tick-green-dark-7c51670792976aa701f655346e341dde.svg";